module.exports = __webpack_public_path__ + "static/media/Srinath.9ac28d7f.gif";